
const manuallyClosed = localStorage.getItem("navigation-manual-closed")==="true";

export default class AppState {

  navigationOpen = false;
  navigationManualClosed = manuallyClosed;
}
